import React from "react";
import { StarIcon } from "lucide-react";
import { testimonialPlaceholders } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function Testimonials() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-138" data-mp="3fz5mltnqbceo">
      <SectionHeading eyebrow="LA CONFIANCE DES PROFESSEURS DE GUITARE" title={<>Ce qu'en disent <span className="text-gold" data-id="element-140" data-mp="36zimdb6qkcn7">les professeurs</span></>} data-id="element-139" data-mp="3b0uebnd319yk" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-3" data-id="element-141" data-mp="36wmo1lqz7ly8">
        {testimonialPlaceholders.map((t, i) => <figure key={i} className="flex flex-col rounded-2xl border border-line bg-ink p-5 sm:p-6" data-id="element-142" data-mp="2x0jlies7plar" data-mpi={i}>
            <div className="flex gap-1 text-gold" aria-label="5 étoiles sur 5" data-id="element-143" data-mp="2s28e0ape3mvp">
              {Array.from({
            length: 5
          }).map((_, j) => <StarIcon key={j} className="h-4 w-4 fill-current" aria-hidden data-id="element-144" data-mp="v8wtc9wl3kcp" data-mpi={j} />)}
            </div>
            <blockquote className="mt-4 font-serif text-base italic leading-relaxed text-cream sm:text-lg" data-id="element-145" data-mp="qb4z398gvm5c">« {t.quote} »</blockquote>
            <figcaption className="mt-auto pt-5" data-id="element-146" data-mp="m4rmk87wj64b">
              <p className="font-bold text-cream" data-id="element-147" data-mp="m6m91qytn6ai">{t.name}</p>
              <p className="text-sm text-mute" data-id="element-148" data-mp="78a99bg5jhf4">{t.role}</p>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}